import apiHttpClient from "./ApiHttpService";

export default class ProjectService {
  getProjectInfos() {
    return apiHttpClient.get(
      `trs/mobile/Project/getProjectInfos`
    );
  }
}
